// // src/app/modules/Auth/pages/Registration.jsx
// import React, { useState } from "react";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { connect, useDispatch } from "react-redux";
// import { injectIntl } from "react-intl";
// import * as auth from "../_redux/authRedux";
// import { register, getUserOrganizations } from "../_redux/authCrud";
// import { useNavigate } from 'react-router-dom';
// import './auth.scss';
// import { Eye, EyeOff, User, Mail, Phone } from 'lucide-react';

// const initialValues = {
//   first_name: "",
//   last_name: "",
//   email: "",
//   phone_number: "",
//   password: "",
//   confirm_password: "",
//   agree_terms: false,
// };

// function Registration(props) {
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const RegistrationSchema = Yup.object().shape({
//     first_name: Yup.string()
//       .min(2, "First name must be at least 2 characters")
//       .max(50, "First name is too long")
//       .required("First name is required"),
//     last_name: Yup.string()
//       .min(2, "Last name must be at least 2 characters")
//       .max(50, "Last name is too long")
//       .required("Last name is required"),
//     email: Yup.string()
//       .email("Invalid email address")
//       .required("Email is required"),
//     phone_number: Yup.string()
//       .matches(/^[+]?[0-9]{10,15}$/, "Enter a valid phone number (e.g., +2348012345678)")
//       .required("Phone number is required"),
//     password: Yup.string()
//       .min(8, "Password must be at least 8 characters")
//       .matches(/[a-z]/, "Password must contain at least one lowercase letter")
//       .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
//       .matches(/[0-9]/, "Password must contain at least one number")
//       .required("Password is required"),
//     confirm_password: Yup.string()
//       .oneOf([Yup.ref('password'), null], 'Passwords must match')
//       .required("Please confirm your password"),
//     agree_terms: Yup.boolean()
//       .oneOf([true], "You must accept the terms and conditions")
//       .required("You must accept the terms and conditions"),
//   });

//   const formik = useFormik({
//     initialValues,
//     validationSchema: RegistrationSchema,
//     onSubmit: (values, { setStatus, setSubmitting }) => {
//       setLoading(true);
//       setStatus('');
      
//       // Register with just personal info - no organization
//       const payload = {
//         first_name: values.first_name,
//         last_name: values.last_name,
//         email: values.email,
//         phone_number: values.phone_number,
//         password: values.password,
//       };

//       register(payload)
//         .then(async (response) => {
//           const { user, tokens } = response.data;
          
//           if (tokens && tokens.access && tokens.refresh) {
//             // Store tokens
//             props.login(tokens.access.token, tokens.refresh.token);
//             dispatch(auth.actions.fulfillUser(user));
            
//             // Check email verification first
//             if (user && !user.email_verified) {
//               setLoading(false);
//               setSubmitting(false);
//               navigate('/auth/activation', { state: { email: values.email } });
//               return;
//             }
            
//             // Fetch organizations
//             try {
//               const orgsResponse = await getUserOrganizations();
//               const organizations = orgsResponse.data.organizations || [];
              
//               dispatch(auth.actions.fulfillOrgs(organizations));
              
//               setLoading(false);
//               setSubmitting(false);
              
//               // Redirect based on organization status
//               if (organizations.length === 0) {
//                 // navigate('/auth/organization-setup');
//                 navigate('/auth/organization-setup', { 
//                     state: { user, fromRegistration: true } 
//                 });
//               } else {
//                 navigate('/dashboard');
//               }
//             } catch (error) {
//               // No organizations or error fetching
//               dispatch(auth.actions.fulfillOrgs([]));
//               setLoading(false);
//               setSubmitting(false);
//             //   navigate('/auth/organization-setup');
//               navigate('/auth/organization-setup', { 
//                     state: { user, fromRegistration: true } 
//                 });
//             }
//           }
//         })
//         .catch((error) => {
//           setLoading(false);
//           setSubmitting(false);
//           const message = error.response?.data?.message || 'An error occurred during registration';
//           setStatus(message);
//         });
//     },
//   });

//   return (
//     <div className="clean-login-card">
//       <div className="login-header">
//         <h1 className="login-title">Create Account</h1>
//         <p className="login-subtitle">Enter your personal information to get started</p>
//       </div>

//       {formik.status && (
//         <div className={`login-alert ${formik.status.includes('successful') ? 'success' : ''}`}>
//           {formik.status}
//         </div>
//       )}

//       <form onSubmit={formik.handleSubmit} className="login-form">
//         {/* Name Fields */}
//         <div className="form-row">
//           <div className="form-group">
//             <label className="form-label">First Name</label>
//             <div className="input-with-icon">
//               <User size={18} className="input-icon" />
//               <input
//                 type="text"
//                 name="first_name"
//                 placeholder="John"
//                 autoComplete="given-name"
//                 className={`form-control with-icon ${
//                   formik.touched.first_name && formik.errors.first_name ? 'error' : ''
//                 }`}
//                 {...formik.getFieldProps("first_name")}
//               />
//             </div>
//             {formik.touched.first_name && formik.errors.first_name && (
//               <div className="form-error">{formik.errors.first_name}</div>
//             )}
//           </div>

//           <div className="form-group">
//             <label className="form-label">Last Name</label>
//             <div className="input-with-icon">
//               <User size={18} className="input-icon" />
//               <input
//                 type="text"
//                 name="last_name"
//                 placeholder="Doe"
//                 autoComplete="family-name"
//                 className={`form-control with-icon ${
//                   formik.touched.last_name && formik.errors.last_name ? 'error' : ''
//                 }`}
//                 {...formik.getFieldProps("last_name")}
//               />
//             </div>
//             {formik.touched.last_name && formik.errors.last_name && (
//               <div className="form-error">{formik.errors.last_name}</div>
//             )}
//           </div>
//         </div>

//         {/* Email */}
//         <div className="form-group">
//           <label className="form-label">Email</label>
//           <div className="input-with-icon">
//             <Mail size={18} className="input-icon" />
//             <input
//               type="email"
//               name="email"
//               placeholder="john@company.com"
//               autoComplete="email"
//               className={`form-control with-icon ${
//                 formik.touched.email && formik.errors.email ? 'error' : ''
//               }`}
//               {...formik.getFieldProps("email")}
//             />
//           </div>
//           {formik.touched.email && formik.errors.email && (
//             <div className="form-error">{formik.errors.email}</div>
//           )}
//         </div>

//         {/* Phone */}
//         <div className="form-group">
//           <label className="form-label">Phone Number</label>
//           <div className="input-with-icon">
//             <Phone size={18} className="input-icon" />
//             <input
//               type="tel"
//               name="phone_number"
//               placeholder="+2348012345678"
//               autoComplete="tel"
//               className={`form-control with-icon ${
//                 formik.touched.phone_number && formik.errors.phone_number ? 'error' : ''
//               }`}
//               {...formik.getFieldProps("phone_number")}
//             />
//           </div>
//           <p className="form-hint">Include country code (e.g., +234 for Nigeria)</p>
//           {formik.touched.phone_number && formik.errors.phone_number && (
//             <div className="form-error">{formik.errors.phone_number}</div>
//           )}
//         </div>

//         {/* Password */}
//         <div className="form-group">
//           <label className="form-label">Password</label>
//           <div className="password-field">
//             <input
//               type={showPassword ? "text" : "password"}
//               name="password"
//               placeholder="Create a strong password"
//               autoComplete="new-password"
//               className={`form-control ${
//                 formik.touched.password && formik.errors.password ? 'error' : ''
//               }`}
//               {...formik.getFieldProps("password")}
//             />
//             <button
//               type="button"
//               className="password-toggle"
//               onClick={() => setShowPassword(!showPassword)}
//               tabIndex={-1}
//             >
//               {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//             </button>
//           </div>
//           <p className="form-hint">At least 8 characters with uppercase, lowercase, and number</p>
//           {formik.touched.password && formik.errors.password && (
//             <div className="form-error">{formik.errors.password}</div>
//           )}
//         </div>

//         {/* Confirm Password */}
//         <div className="form-group">
//           <label className="form-label">Confirm Password</label>
//           <div className="password-field">
//             <input
//               type={showConfirmPassword ? "text" : "password"}
//               name="confirm_password"
//               placeholder="Confirm your password"
//               autoComplete="new-password"
//               className={`form-control ${
//                 formik.touched.confirm_password && formik.errors.confirm_password ? 'error' : ''
//               }`}
//               {...formik.getFieldProps("confirm_password")}
//             />
//             <button
//               type="button"
//               className="password-toggle"
//               onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//               tabIndex={-1}
//             >
//               {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//             </button>
//           </div>
//           {formik.touched.confirm_password && formik.errors.confirm_password && (
//             <div className="form-error">{formik.errors.confirm_password}</div>
//           )}
//         </div>

//         {/* Terms & Conditions */}
//         <div className="form-group">
//           <label className="terms-check">
//             <input
//               type="checkbox"
//               name="agree_terms"
//               {...formik.getFieldProps("agree_terms")}
//             />
//             <span>
//               I agree to the{' '}
//               <a href="https://sety.io/terms" className="terms-link" target="_blank" rel="noopener noreferrer">
//                 Terms & Conditions
//               </a>
//               {' '}and{' '}
//               <a href="https://sety.io/privacy" className="terms-link" target="_blank" rel="noopener noreferrer">
//                 Privacy Policy
//               </a>
//             </span>
//           </label>
//           {formik.touched.agree_terms && formik.errors.agree_terms && (
//             <div className="form-error">{formik.errors.agree_terms}</div>
//           )}
//         </div>

//         {/* Submit Button */}
//         <button
//           type="submit"
//           disabled={formik.isSubmitting || loading}
//           className="submit-btn"
//         >
//           {loading ? (
//             <>
//               Creating account...
//               <span className="spinner"></span>
//             </>
//           ) : (
//             'Create Account'
//           )}
//         </button>

//         {/* Login Link */}
//         <div className="form-footer">
//           Already have an account?{' '}
//           <button
//             type="button"
//             className="footer-link"
//             onClick={() => navigate('/auth/login')}
//           >
//             Sign in
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default injectIntl(connect(null, auth.actions)(Registration));




// src/app/modules/Auth/pages/Registration.jsx
import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect, useDispatch } from "react-redux";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { register, socialLogin, getUserOrganizations } from "../_redux/authCrud";
import { consumePendingInvite } from "../pendingInvite";
import axios from "axios";
import appConfig from "../../../../config";
import { useNavigate } from 'react-router-dom';
import './auth.scss';
import { Eye, EyeOff, User, Mail, Phone } from 'lucide-react';
import { useGoogleLogin, useGoogleOneTapLogin } from '@react-oauth/google';
import AppleSignin from 'react-apple-signin-auth';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../../../auth/microsoftConfig';

const initialValues = {
  first_name: "",
  last_name: "",
  email: "",
  phone_number: "",
  password: "",
  confirm_password: "",
  agree_terms: false,
};

function Registration(props) {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [socialLoading, setSocialLoading] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { instance } = useMsal();

  const RegistrationSchema = Yup.object().shape({
    first_name: Yup.string().min(2).max(50).required("First name is required"),
    last_name: Yup.string().min(2).max(50).required("Last name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phone_number: Yup.string().matches(/^[+]?[0-9]{10,15}$/, "Valid phone required").required(),
    password: Yup.string().min(8).matches(/[a-z]/).matches(/[A-Z]/).matches(/[0-9]/).required(),
    confirm_password: Yup.string().oneOf([Yup.ref('password')], 'Passwords must match').required(),
    agree_terms: Yup.boolean().oneOf([true], "You must accept the terms").required(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: RegistrationSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      setStatus('');
      
      try {
        const response = await register({
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          phone_number: values.phone_number,
          password: values.password,
        });
        const { user, tokens } = response.data;
        await handlePostAuth(user, tokens);
      } catch (error) {
        setStatus(error.response?.data?.message || 'Registration failed');
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    },
  });

  const handlePostAuth = async (user, tokens) => {
    if (tokens && tokens.access && tokens.refresh) {
      props.login(tokens.access.token, tokens.refresh.token);
      dispatch(auth.actions.fulfillUser(user));
      
      if (user && !user.email_verified) {
        navigate('/auth/activation', { state: { email: user.email } });
        return;
      }

      // If this signup was triggered from an invite link, join that org now
      // that we have a valid auth token (real accept-invite requires one).
      await consumePendingInvite(axios, appConfig.URL);

      try {
        const orgsResponse = await getUserOrganizations();
        const organizations = orgsResponse.data.organizations || [];
        dispatch(auth.actions.fulfillOrgs(organizations));

        if (organizations.length === 0) {
          navigate('/auth/organization-setup', { state: { user, fromRegistration: true } });
        } else {
          navigate('/dashboard');
        }
      } catch (error) {
        dispatch(auth.actions.fulfillOrgs([]));
        navigate('/auth/organization-setup', { state: { user, fromRegistration: true } });
      }
    }
  };

  // One-Tap
  useGoogleOneTapLogin({
    onSuccess: async (credentialResponse) => {
      setSocialLoading('google');
      try {
        // Just provider and JWT credential
        const response = await socialLogin({
          provider: 'google',
          token: credentialResponse.credential,
        });
        
        const { user, tokens } = response.data;
        await handlePostAuth(user, tokens);
      } catch (error) {
        console.error('One-tap error:', error);
        const message = error.response?.data?.message || 'Google sign-up failed';
        formik.setStatus(message);
      } finally {
        setSocialLoading(null);
      }
    },
    onError: () => console.log('One-tap failed'),
    auto_select: true,
    cancel_on_tap_outside: false,
  });

  // Manual Google
   const handleGoogleSignIn = useGoogleLogin({
     onSuccess: async (tokenResponse) => {
       setSocialLoading('google');
       formik.setStatus('');
       
       try {
         // Get user info
         const userInfoResponse = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
           headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
         });
         const userInfo = await userInfoResponse.json();
         
         // Send access_token + email + name to backend
         const response = await socialLogin({
           provider: 'google',
           token: tokenResponse.access_token,
           email: userInfo.email,
           name: userInfo.name,
         });
         
         const { user, tokens } = response.data;
         await handlePostAuth(user, tokens);
         
       } catch (error) {
         console.error('Google sign-in error:', error);
         const message = error.response?.data?.message || 'Google sign-in failed';
         formik.setStatus(message);
       } finally {
         setSocialLoading(null);
       }
     },
     onError: () => {
       console.error('Google sign-in failed');
       formik.setStatus('Google sign-in was cancelled or failed');
     },
   });

  // Apple
  const handleAppleSuccess = async (response) => {
    setSocialLoading('apple');
    formik.setStatus('');
    
    try {
      const appleResponse = await socialLogin({
        provider: 'apple',
        token: response.authorization.id_token,
      });
      const { user, tokens } = appleResponse.data;
      await handlePostAuth(user, tokens);
    } catch (error) {
      console.error('Apple sign-in error:', error);
      const message = error.response?.data?.message || 'Apple sign-up failed';
      formik.setStatus(message);
    } finally {
      setSocialLoading(null);
    }
  };

  const handleMicrosoftSignIn = async () => {
    setSocialLoading('microsoft');
    formik.setStatus('');
    try {
      const result = await instance.loginPopup(loginRequest);
      const response = await socialLogin({
        provider: 'microsoft',
        token: result.accessToken,
        email: result.account?.username,
        name: result.account?.name,
      });
      const { user, tokens } = response.data;
      await handlePostAuth(user, tokens);
    } catch (error) {
      if (error?.errorCode !== 'user_cancelled') {
        const message = error.response?.data?.message || 'Microsoft sign-up failed';
        formik.setStatus(message);
      }
    } finally {
      setSocialLoading(null);
    }
  };

  return (
    <div className="clean-login-card">
      <div className="login-header">
        <h1 className="login-title">Create Account</h1>
        <p className="login-subtitle">Enter your personal information to get started</p>
      </div>

      {formik.status && <div className="login-alert">{formik.status}</div>}

      {/* Social Auth */}
      <div className="social-auth">
        {/* Microsoft */}
        <button
          type="button"
          onClick={handleMicrosoftSignIn}
          disabled={socialLoading !== null}
          className="google-signin-btn"
        >
          {socialLoading === 'microsoft' ? <span className="spinner"></span> : (
            <>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <rect x="1" y="1" width="8.5" height="8.5" fill="#F25022"/>
                <rect x="10.5" y="1" width="8.5" height="8.5" fill="#7FBA00"/>
                <rect x="1" y="10.5" width="8.5" height="8.5" fill="#00A4EF"/>
                <rect x="10.5" y="10.5" width="8.5" height="8.5" fill="#FFB900"/>
              </svg>
              Continue with Microsoft
            </>
          )}
        </button>

        {/* Google */}
        <button
          type="button"
          onClick={handleGoogleSignIn}
          disabled={socialLoading !== null}
          className="google-signin-btn"
        >
          {socialLoading === 'google' ? <span className="spinner"></span> : (
            <>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M19.8055 10.2292C19.8055 9.55135 19.7508 8.86719 19.6344 8.19661H10.2002V12.0492H15.6014C15.3773 13.2911 14.6571 14.3898 13.6025 15.0879V17.5866H16.825C18.7171 15.8449 19.8055 13.2728 19.8055 10.2292Z" fill="#4285F4"/>
                <path d="M10.2002 20.0006C12.9515 20.0006 15.2664 19.1151 16.8251 17.5865L13.6026 15.0879C12.7015 15.6979 11.5469 16.0433 10.2002 16.0433C7.54257 16.0433 5.29429 14.2834 4.50543 11.9097H1.17773V14.4819C2.7748 17.6544 6.31114 20.0006 10.2002 20.0006Z" fill="#34A853"/>
                <path d="M4.50543 11.9097C4.04543 10.6678 4.04543 9.33337 4.50543 8.09148V5.51929H1.17773C-0.290952 8.43984 -0.290952 11.5613 1.17773 14.4819L4.50543 11.9097Z" fill="#FBBC04"/>
                <path d="M10.2002 3.95805C11.6244 3.936 13.0009 4.47508 14.0401 5.45894L16.8935 2.60552C15.1809 0.990833 12.9297 0.0869522 10.2002 0.109818C6.31114 0.109818 2.7748 2.45601 1.17773 5.51931L4.50543 8.0915C5.29429 5.71783 7.54257 3.95805 10.2002 3.95805Z" fill="#EA4335"/>
              </svg>
              Continue with Google
            </>
          )}
        </button>
 
        <div className="divider">
          <span>Or sign up with email</span>
        </div>
      </div>

      <form onSubmit={formik.handleSubmit} className="login-form">
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">First Name</label>
            <div className="input-with-icon">
              <User size={18} className="input-icon" />
              <input type="text" placeholder="John" className={`form-control with-icon ${formik.touched.first_name && formik.errors.first_name ? 'error' : ''}`} {...formik.getFieldProps("first_name")} />
            </div>
            {formik.touched.first_name && formik.errors.first_name && <div className="form-error">{formik.errors.first_name}</div>}
          </div>

          <div className="form-group">
            <label className="form-label">Last Name</label>
            <div className="input-with-icon">
              <User size={18} className="input-icon" />
              <input type="text" placeholder="Doe" className={`form-control with-icon ${formik.touched.last_name && formik.errors.last_name ? 'error' : ''}`} {...formik.getFieldProps("last_name")} />
            </div>
            {formik.touched.last_name && formik.errors.last_name && <div className="form-error">{formik.errors.last_name}</div>}
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Email</label>
          <div className="input-with-icon">
            <Mail size={18} className="input-icon" />
            <input type="email" placeholder="john@company.com" className={`form-control with-icon ${formik.touched.email && formik.errors.email ? 'error' : ''}`} {...formik.getFieldProps("email")} />
          </div>
          {formik.touched.email && formik.errors.email && <div className="form-error">{formik.errors.email}</div>}
        </div>

        <div className="form-group">
          <label className="form-label">Phone Number</label>
          <div className="input-with-icon">
            <Phone size={18} className="input-icon" />
            <input type="tel" placeholder="+2348012345678" className={`form-control with-icon ${formik.touched.phone_number && formik.errors.phone_number ? 'error' : ''}`} {...formik.getFieldProps("phone_number")} />
          </div>
          <p className="form-hint">Include country code</p>
          {formik.touched.phone_number && formik.errors.phone_number && <div className="form-error">{formik.errors.phone_number}</div>}
        </div>

        <div className="form-group">
          <label className="form-label">Password</label>
          <div className="password-field">
            <input type={showPassword ? "text" : "password"} placeholder="Create password" className={`form-control ${formik.touched.password && formik.errors.password ? 'error' : ''}`} {...formik.getFieldProps("password")} />
            <button type="button" className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
          <p className="form-hint">8+ chars with uppercase, lowercase, number</p>
          {formik.touched.password && formik.errors.password && <div className="form-error">{formik.errors.password}</div>}
        </div>

        <div className="form-group">
          <label className="form-label">Confirm Password</label>
          <div className="password-field">
            <input type={showConfirmPassword ? "text" : "password"} placeholder="Confirm password" className={`form-control ${formik.touched.confirm_password && formik.errors.confirm_password ? 'error' : ''}`} {...formik.getFieldProps("confirm_password")} />
            <button type="button" className="password-toggle" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
              {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
          {formik.touched.confirm_password && formik.errors.confirm_password && <div className="form-error">{formik.errors.confirm_password}</div>}
        </div>

        <div className="form-group">
          <label className="terms-check">
            <input type="checkbox" {...formik.getFieldProps("agree_terms")} />
            <span>I agree to the <a href="https://sety.io/terms" className="terms-link">Terms</a> and <a href="https://sety.io/privacy" className="terms-link">Privacy Policy</a></span>
          </label>
          {formik.touched.agree_terms && formik.errors.agree_terms && <div className="form-error">{formik.errors.agree_terms}</div>}
        </div>

        <button type="submit" disabled={loading} className="submit-btn">
          {loading ? <><span>Creating account...</span><span className="spinner"></span></> : 'Create Account'}
        </button>

        <div className="form-footer">
          Already have an account? <button type="button" className="footer-link" onClick={() => navigate('/auth/login')}>Sign in</button>
        </div>
      </form>
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Registration));